function createDom(type, className, parent) {
  parent = parent || document.body;
  const dom = document.createElement(type);
  parent.appendChild(dom);
  if (className)
    dom.className = className;
  return dom;
}
function createDiv(className, parent) {
  return createDom("div", className, parent);
}
function getPhotoURL(player) {
  return `url(${player.photoSmall || player.photo})`;
}
function removeDom(dom, parent) {
  parent = parent || document.body;
  parent.removeChild(dom);
}
function removeTimestepBuildSplashScreen() {
  const splashScreen = document.getElementById("splashScreen");
  if (splashScreen) {
    document.body.removeChild(splashScreen);
  }
}
function makeClickable(dom, onClick, params) {
  dom.onclick = () => onClick(params);
  return dom;
}
export {
  createDiv,
  createDom,
  getPhotoURL,
  makeClickable,
  removeDom,
  removeTimestepBuildSplashScreen
};
